import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Problem = ({
  openModal
}) => {
  // Add the openModal prop and the helper function
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-165">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-166">
      <p className="mb-6 leading-relaxed" data-id="element-167">
        Een groot onderzoek in Engeland laat zien dat straffen heel slecht is
        voor honden. Wetenschappers onderzochten bijna 4.000 honden. Ze
        ontdekten iets schokkends.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-168">
        Honden die gestraft worden, zijn 3 keer vaker agressief naar hun baasje.
        Dit betekent dat ze vaker grommen, blaffen of bijten.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-169">
        De onderzoekers waren Casey en zijn team (Casey et al. (2014).) Hun
        onderzoek kwam uit in 2014. Nu waarschuwen Amee en andere experts ook in
        Nederland: stop met streng straffen.
      </p>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-170">
        Onderzoek met 3897 honden
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-171">
        Tussen 2012 en 2014 deden wetenschappers een groot onderzoek. Ze
        onderzochten 3.897 hondeneigenaren in Engeland en hun hond.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-172">
        De resultaten waren erg duidelijk en veel baasjes doen dit nog steeds
        fout.
      </p>
      <div className="w-full mb-6" data-id="element-173">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KEgUQgawG75GbMn1oV55H/freepik__the-style-is-candid-image-photography-with-natural__57097_%281%29.png" alt="Gedragsdeskundige observeert een Labrador in een park in Amsterdam" className="w-full h-auto rounded-lg shadow-md" data-id="element-174" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-175">
          Onderzoek toont aan: straffen en corrigeren maakt meer kapot dan je
          lief is.
        </p>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-176">
        Conclusie: Straffen maakt honden agressiever
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-177">
        Amee legt het tijdens{' '}
        <a href="https://stresslessdogs.nl/mcc-gpm-adv1" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-178">
          haar online presentatie
        </a>{' '}
        uit. Honden die gestraft worden, gedragen zich slechter. Ze zijn niet
        rustiger. Ze worden juist agressiever. Probleemgedrag neemt toe.
      </p>
      <p className="mb-6 leading-relaxed font-semibold" data-id="element-179">De cijfers:</p>
      <ul className="mb-6 list-disc pl-5 space-y-2" data-id="element-180">
        <li data-id="element-181">
          Honden die alleen beloond en positief getrained worden: 12 van de 100
          zijn agressief
        </li>
        <li data-id="element-182">Honden die gestraft worden: 36 van de 100 zijn agressief</li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-183">
        Dit is een groot verschil. Sterker nog, straffen maakt het probleem
        alleen maar erger!
      </p>
    </section>;
};